import { clearRegistrationUser } from 'utils/fns';
import {
  enriquecerComValidacao,
  IniciativaEnriquecivel,
  ValidacaoIniciativa,
} from 'utils/participantes-validacao';
import { api } from './api';
import { dedupedFetch } from './cache';

interface ValidacaoIniciativaDTO {
  _id: string;
  totalOriginal: number;
  totalValidos: number;
  validos: string[];
}

/** Chave de cache do mapa global de validação (use para `invalidateCache`). */
export const CACHE_KEY_MAPA_VALIDACAO = 'validacao-etapa1-final-mapa';

export const buscarMapaValidacaoEtapa1 = (): Promise<Map<string, ValidacaoIniciativa>> =>
  dedupedFetch(
    CACHE_KEY_MAPA_VALIDACAO,
    async () => {
      const mapa = new Map<string, ValidacaoIniciativa>();
      try {
        const { data } = await api.post('/find/validacao_etapa1_final', {}, {
          headers: { Range: `items=0-500` },
        });
        if (!Array.isArray(data)) return mapa;

        (data as ValidacaoIniciativaDTO[]).forEach((item) => {
          if (!item?._id) return;
          const validos = new Set<string>(
            (item.validos || []).map((chave) => clearRegistrationUser(chave))
          );
          mapa.set(item._id, {
            totalOriginal: Number(item.totalOriginal) || 0,
            totalValidos: Number(item.totalValidos) || 0,
            validos,
          });
        });
      } catch (error) {
        // Degrada com segurança: sem o mapa, os cards caem no fallback
        // (comportamento atual) em vez de quebrar a listagem.
        console.error('[validacao-etapa1-final] falha ao buscar mapa de validação', error);
      }
      return mapa;
    },
    60_000
  );

export const aplicarValidacaoEmIniciativas = async <T extends IniciativaEnriquecivel>(
  iniciativas: T[]
): Promise<T[]> => {
  const mapa = await buscarMapaValidacaoEtapa1();
  return enriquecerComValidacao(iniciativas, mapa);
};
